/// <reference types="./getChangelogEvents.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { EventType, ok, } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryMany } from '../QueryFunctions.js';
import { toOpaqueCursor } from '../search/OpaqueCursor.js';
import { assertIsDefined } from '../utils/AssertUtils.js';
import { resolveConnectionPagingAndOrdering } from '../utils/ConnectionUtils.js';
import { generateGetChangelogEventsQuery } from './ChangelogQueryGenerator.js';
export async function eventGetChangelogEvents(database, context, query, paging, entity) {
    const sqlQueryResult = generateGetChangelogEventsQuery(database, query, paging, entity);
    if (sqlQueryResult.isError())
        return sqlQueryResult;
    const connectionResult = await queryMany(database, context, sqlQueryResult.value);
    if (connectionResult.isError())
        return connectionResult;
    const { hasMore, edges } = resolveConnectionPagingAndOrdering(paging, connectionResult.value);
    const entitiesInfoResult = await getEntityInfoForEvents(database, context, edges);
    if (entitiesInfoResult.isError())
        return entitiesInfoResult;
    return ok({
        hasMore,
        edges: edges.map((edge) => convertEdge(database, entitiesInfoResult.value, edge)),
    });
}
async function getEntityInfoForEvents(database, context, events) {
    const entityEventIds = events
        .filter((it) => it.type !== EventType.updateSchema)
        .map((it) => it.id);
    if (entityEventIds.length === 0) {
        return ok([]);
    }
    const { sql, query, addValueList } = createSqliteSqlQuery();
    sql `SELECT eev.events_id, e.uuid, e.uuid_before_delete, e.auth_key, e.resolved_auth_key, ev.type, ev.name, ev.version FROM event_entity_versions eev`;
    sql `JOIN entity_versions ev ON eev.entity_versions_id = ev.id`;
    sql `JOIN entities e ON ev.entities_id = e.id`;
    sql `WHERE eev.events_id IN ${addValueList(entityEventIds)}`;
    return queryMany(database, context, query);
}
function convertEdge(database, entityRows, row) {
    const cursor = toOpaqueCursor(database, 'int', row.id);
    const id = row.uuid;
    const createdBy = row.created_by;
    const createdAt = new Date(row.created_at);
    switch (row.type) {
        case EventType.createPrincipal:
            return {
                cursor,
                id,
                type: EventType.createPrincipal,
                createdAt,
                createdBy,
            };
        case EventType.updateSchema:
            return {
                cursor,
                id,
                type: EventType.updateSchema,
                createdAt,
                createdBy,
                version: row.version,
            };
        default: {
            const entities = [];
            for (const entityRow of entityRows) {
                if (entityRow.events_id === row.id) {
                    entities.push({
                        id: resolveId(entityRow),
                        name: entityRow.name,
                        version: entityRow.version,
                        type: entityRow.type,
                        authKey: entityRow.auth_key,
                        resolvedAuthKey: entityRow.resolved_auth_key,
                    });
                }
            }
            return { cursor, id, type: row.type, createdAt, createdBy, entities };
        }
    }
}
function resolveId(row) {
    const id = row.uuid ?? row.uuid_before_delete;
    assertIsDefined(id);
    return id;
}
//# sourceMappingURL=getChangelogEvents.js.map